export default __webpack_public_path__ + "static/media/151-maps-and-flags-2.5f4666a0.png";